import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material"
import StopIcon from "@mui/icons-material/Stop"
import { useState } from "react"

const AIProgress = ({ generationPanelCount, handleRequestStop, message }) => {
  const [requestedStop, setRequestedStop] = useState(false)

  const [overrideMessage, setOverrideMessage] = useState("")

  return (
    <>
      {generationPanelCount > 0 && (
        <Stack direction="row" gap={2} sx={{ alignItems: "center" }}>
          <Box>
            <CircularProgress size={20} />
          </Box>
          <Box>
            <Typography variant="caption">
              {overrideMessage || message}
            </Typography>
          </Box>
          <Box>
            <Tooltip title="Stop">
              <span>
                <IconButton
                  onClick={() => {
                    setRequestedStop(true)
                    handleRequestStop && handleRequestStop()
                    setOverrideMessage("Stopping...")
                  }}
                  disabled={requestedStop}
                >
                  <StopIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Stack>
      )}
    </>
  )
}

export default AIProgress
